module.exports = __webpack_public_path__ + "img/6.31680a64.jpg";